import { Component, DestroyRef, Input, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, interval } from 'rxjs';
import { LoggerService } from '@app/shared/services/logger.service';
import { SharedModule } from '@app/shared/shared.module';
import { TooltipDirective } from '@app/shared/directives/tooltip.directive';
import { NativeService } from '@app/shared/services/native.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@app/shared/models/user.model';
import { BadgeComponent } from '@app/shared/components/badge/badge.component';
import { EventManager } from '@app/shared/utils/event-manager';
import { environment } from '@environments/environment';
import { UserRepository } from '@app/shared/state/user/user.repository';

type toolTipPosition = 'left' | 'right';

@Component({
  selector: 'slotcom-rich-club-icon',
  standalone: true,
  imports: [SharedModule, TooltipDirective, BadgeComponent],
  templateUrl: './rich-club-icon.component.html',
  styleUrl: './rich-club-icon.component.scss',
  animations: [
    trigger('pulse', [
      state(
        'small',
        style({
          transform: 'scale(1)',
        })
      ),
      state(
        'big',
        style({
          transform: 'scale(1.2)',
          filter: 'drop-shadow(-10px -10px 5px purple) drop-shadow(10px 10px 5px purple)',
        })
      ),
      transition('small <=> big', animate('1500ms ease-in-out')),
    ]),
  ],
})
export class RichclubIconComponent implements OnInit {
  public readonly loggerService = inject(LoggerService);
  private readonly userRepo = inject(UserRepository);
  private readonly nativeService = inject(NativeService);
  private readonly translateService = inject(TranslateService);
  private readonly eventManager = inject(EventManager);

  @Input() toolTipPosition: toolTipPosition = 'left';

  componentDestroy: () => Observable<unknown>;
  private destroyRef = inject(DestroyRef);
  abTest = false;

  lang: string;
  isMobileApp: boolean;
  state = signal<'small' | 'big'>('small');
  bonusAvailable: boolean;

  get user(): User {
    return this.userRepo.getUser();
  }

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.isMobileApp = this.nativeService.isNative();

    this.eventManager.nextRichBonusRedeemDate$.subscribe((state) => {
      this.bonusAvailable = state;
    });

    this.eventManager.isNextRichBonusAvailable(new Date(this.user.nextRichBonusRedeemDate).getTime());

    interval(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.state.set(this.state() === 'small' ? 'big' : 'small');
      });
  }

  openAppchargeLanding() {
    window.open(environment.richClubURL, '_blank');
  }
}
